'use client';

import { Box, Typography } from '@mui/material';
import './ChatList.css';

const ChatList = ({ chats, selectedChat, onChatSelect }) => {
  const formatChatListDate = dateString => {
    if (!dateString) return '';

    // Ensure dateString is treated as UTC by appending 'Z' if missing
    const utcDate = dateString.endsWith('Z') ? dateString : `${dateString}Z`;

    // Create a date object from the UTC time string
    const date = new Date(utcDate);

    // Format: "Tue, 9:12 AM" as shown in the image using local time
    const day = date.toLocaleDateString('en-US', { weekday: 'short' });
    const time = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

    return `${day}, ${time}`;
  };

  const formatTime = dateString => {
    if (!dateString) return '';

    // Ensure dateString is treated as UTC by appending 'Z' if missing
    const utcDate = dateString.endsWith('Z') ? dateString : `${dateString}Z`;

    // Convert UTC time to local time
    const date = new Date(utcDate);
    return date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
  };

  return (
    <Box className="chat-list">
      {chats.length === 0 ? (
        <Box className="no-chats">
          <Typography>No chats available</Typography>
        </Box>
      ) : (
        <>
          {chats.map(chat => (
            <Box
              key={chat.id}
              className={`chat-list-item ${selectedChat && selectedChat.id === chat.id ? 'selected' : ''} ${
                chat.hasUnreadMessages ? 'unread' : ''
              }`}
              onClick={() => onChatSelect(chat)}
            >
              <Box className="chat-list-item-avatar">
                {chat.recipient_details && chat.recipient_details.profile_image ? (
                  <img
                    src={chat.recipient_details.profile_image || '/placeholder.svg'}
                    alt={`${chat.recipient_details.first_name} ${chat.recipient_details.last_name}`}
                    className="chat-avatar"
                  />
                ) : (
                  <Box className="chat-avatar-fallback">
                    {chat.recipient_details && chat.recipient_details.first_name
                      ? chat.recipient_details.first_name.charAt(0)
                      : 'U'}
                  </Box>
                )}
              </Box>
              <Box className="chat-list-item-content">
                <Box className="chat-list-item-header">
                  <Typography className="chat-list-item-name">
                    {chat.recipient_details && chat.recipient_details.first_name}{' '}
                    {chat.recipient_details && chat.recipient_details.last_name}
                  </Typography>
                  <Box className="chat-list-item-time-container">
                    <Typography className="chat-date">
                      {formatChatListDate(chat.updated_at)}
                    </Typography>
                    <Typography className="chat-time">
                      {chat.messages && chat.messages.length > 0
                        ? formatTime(chat.messages[chat.messages.length - 1].created_at)
                        : ''}
                    </Typography>
                  </Box>
                </Box>
                <Typography
                  className={`chat-list-item-message ${chat.hasUnreadMessages ? 'unread-message' : ''}`}
                >
                  {(() => {
                    if (!chat.messages || chat.messages.length === 0) return 'Learner';
                    const last = chat.messages[chat.messages.length - 1];
                    if (last.file_url) {
                      return `📎 ${last.file_name || 'file'}`;
                    }
                    return last.message || 'Learner';
                  })()}
                </Typography>
              </Box>
            </Box>
          ))}
          {/* Add spacer to ensure the list always takes full height */}
          <Box className="chat-list-spacer" />
        </>
      )}
    </Box>
  );
};

export default ChatList;
